import "./Header.scss";

const Header = () => {
  return (
    <div className="header">
      <span className="text-shadow"> Apple Products</span>
    </div>
  );
};

export default Header;
